"use client";

import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@repo/design-system/components/ui/accordion";
import { useMemo } from "react";
import { useLanguage } from "~/translations/loader/use-language";

/**
 * FAQ1 - General Application Process
 * Uses econ_faq_1_q1-9 and econ_faq_1_a1-9 translations
 */
export default function FAQ1Econ() {
  const $ = _c(9);
  const t = useLanguage();
  let items;
  if ($[0] !== t) {
    items = [];
    for (let i = 1; i <= 9; i++) {
      const questionKey = `econ_faq_1_q${i}` as keyof typeof t;
      const answerKey = `econ_faq_1_a${i}` as keyof typeof t;
      if (t[questionKey] && t[answerKey]) {
        items.push({
          question: t[questionKey],
          answer: t[answerKey]
        });
      }
    }
    $[0] = t;
    $[1] = items;
  } else {
    items = $[1];
  }
  const faqs = items;
  let t0;
  if ($[2] !== t.econ_faq_general_HL) {
    t0 = <h2 className="mb-10 text-center font-bold text-4xl text-primary xl:mb-20 xl:text-5xl" data-source="lc">{t.econ_faq_general_HL}</h2>;
    $[2] = t.econ_faq_general_HL;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== faqs) {
    t1 = <Accordion className="space-y-1" type="multiple">{faqs.map(_temp)}</Accordion>;
    $[4] = faqs;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t0 || $[7] !== t1) {
    t2 = <section className="outer-container bg-white py-container text-foreground print:hidden" id="faq1"><div className="inner-container">{t0}{t1}</div></section>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(entry) {
  return <AccordionItem className="border-0" key={entry.question} value={entry.question}><AccordionTrigger className="cursor-pointer gap-4 bg-gray-100 p-3 text-left font-bold text-lg hover:text-primary hover:no-underline" data-source="lc" icon="cross" iconClassName="text-primary">{entry.question}</AccordionTrigger><AccordionContent className="bg-gray-100 px-3 pb-3"><div className="text-lg [&_p]:mb-2" dangerouslySetInnerHTML={{
        __html: entry.answer
      }} data-source="lc" /></AccordionContent></AccordionItem>;
}